module.exports = __webpack_public_path__ + "img/ReturnIcon-SVG.1d128516.svg";